export default __webpack_public_path__ + "locales/fi/PeopleTranslations.json?hash=d1415ff7e337c83f25a3bbf1dcff943d";